import * as actionsTypes from './actionsTypes';
import * as API from '../../API/API';

export const fetchMoviesGenresID = () => ({
  type: actionsTypes.FETCH_GENRES_MOVIES_ID,
  payload: API.fetch_genres_movies_id(),
});

export const fetchTvGenresID = () => ({
  type: actionsTypes.FETCH_GENRES_TV_ID,
  payload: API.fetch_genres_tv_id(),
});
